module.exports = __webpack_public_path__ + "img/20200609_114417.9a608c7e.jpg";